module.exports = __webpack_public_path__ + "img/MachineRobustness.fdb32821.png";